import Vue from "vue";
import Router from "vue-router";
import MainLayout from "@/components/MainLayout";
import AppLayout from "@/components/AppLayout";
import SecondLayout from "@/components/SecondLayout";
import Login from "@/components/Login";

Vue.use(Router);

const router = new Router({
  //mode: 'history',
  routes: [
    {
      path: "/",
      name: "MainLayout",
      component: MainLayout,
      redirect: "/appList",
      children: [
        {
          path: "/appList",
          meta: {
            icon: "el-icon-house",
            title: "应用管理",
            auth: "1,9",
            node: "*",
          },
          name: "menu_app",
          component: () => import("@/pages/appList"),
        },
        {
          path: "/roleLib",
          component: SecondLayout,
          meta: {
            icon: "el-icon-house",
            title: "角色管理",
            auth: "1,9",
            node: "*",
          },
          name: "menu_role_lib",
          redirect: "/roleLib/sysRoleList",
          children: [
            {
              path: "/roleLib/sysRoleList",
              meta: { icon: "el-icon-s-fold", title: "系统上传角色" },
              component: () => import("@/pages/roleLib/sysRoleList"),
            },
            {
              path: "/roleLib/userRoleList",
              meta: { icon: "el-icon-s-unfold", title: "用户上传角色" },
              component: () => import("@/pages/roleLib/userRoleList"),
            },
            {
              path: "/roleLib/roleLang",
              component: () => import("@/pages/roleLib/roleLang"),
              meta: { icon: "el-icon-s-promotion", title: "角色翻译" },
            },
          ],
        },
        {
          path: "/system",
          component: SecondLayout,
          meta: {
            icon: "el-icon-s-tools",
            title: "系统管理",
            auth: "9",
            node: "*",
          },
          name: "menu_dahboard",
          redirect: "/system/index",
          children: [
            {
              path: "/system/index",
              meta: { icon: "el-icon-s-home", title: "系统预览" },
              name: "menu_sys_index",
              component: () => import("@/pages/sys/index"),
            },
            {
              path: "/system/order",
              meta: { icon: "el-icon-s-order", title: "总订单管理" },
              name: "menu_sys_order",
              component: () => import("@/pages/sys/order"),
            },
            {
              path: "/system/order_query",
              meta: { icon: "el-icon-s-help", title: "订单查询" },
              name: "menu_sys_order_query",
              component: () => import("@/pages/sys/order_query"),
            },
             {
              path: "/system/user_query",
              meta: { icon: "el-icon-s-opportunity", title: "用户查询" },
              name: "menu_sys_user_query",
              component: () => import("@/pages/sys/user_query"),
            },
            {
              path: "/system/report_user",
              meta: { icon: "el-icon-s-data", title: "日用户报表" },
              name: "menu_sys_report_user",
              component: () => import("@/pages/sys/report_user"),
            },
            /*{
              path: "/system/report_daily_app",
              meta: { icon: "el-icon-s-marketing", title: "收益日报表" },
              name: "menu_sys_report_daily_app",
              component: () => import("@/pages/sys/report_daily_app"),
            },

            {
              path: "/system/report_app",
              meta: { icon: "el-icon-s-grid", title: "应用收益报表" },
              name: "menu_sys_report_app",
              component: () => import("@/pages/sys/report_app"),
            },
            {
              path: "/system/report_api",
              meta: { icon: "el-icon-s-management", title: "接口花费报表" },
              name: "menu_sys_report_api",
              component: () => import("@/pages/sys/report_api"),
            },*/
            {
              path: '/system/report_hourly',
              component: () => import('@/pages/sys/report_hourly'),
              name: 'menu_report_hourly',
              meta:{ icon:"el-icon-menu", title:'小时趋势报表'},
            },
            {
              path: "/system/user_list",
              component: () => import("@/pages/sys/list"),
              meta: { icon: "el-icon-user-solid", title: "用户列表" },
              name: "menu_user_list",
            },
            {
              path: "/system/feedback",
              component: () => import("@/pages/sys/feedback_list"),
              meta: { icon: "el-icon-s-ticket", title: "用户反馈" },
              name: "menu_user_feedback",
            },
            {
              path: "/system/admin",
              meta: { icon: "el-icon-s-custom", title: "管理员" },
              name: "menu_sys_admin",
              component: () => import("@/pages/todo"),
            },
          ],
        },
        {
          path: "/global",
          component: SecondLayout,
          meta: {
            icon: "el-icon-s-tools",
            title: "集群管理",
            auth: "9",
            node: "main",
          },
          name: "global_dahboard",
          redirect: "/global/appList",
          children: [
            {
              path: "/global/appList",
              meta: { icon: "el-icon-s-grid", title: "应用列表" },
              name: "menu_global_app_list",
              component: () => import("@/pages/global/app_list"),
            },
            {
              path: "/global/server",
              meta: { icon: "el-icon-s-cooperation", title: "集群服务器" },
              name: "menu_global_server",
              component: () => import("@/pages/global/server"),
            },
            {
              path: "/global/report",
              component: SecondLayout,
              meta: { icon: "el-icon-s-data", title: "数据报表" },
              name: "menu_report",
              redirect: "/global/report/profit",
              children: [
                /*{
                  path: "/global/report/report_daily",
                  meta: { icon: "el-icon-odometer", title: "汇总收益" },
                  name: "menu_global_report",
                  component: () => import("@/pages/global/report_daily"),
                },
                {
                  path: "/global/report/report_daily_app",
                  meta: { icon: "el-icon-data-line", title: "每日应用收益" },
                  name: "menu_global_report_daily_app",
                  component: () => import("@/pages/global/report_daily_app"),
                },*/
                {
                  path: "/global/report_total",
                  meta: { icon: "el-icon-s-data", title: "汇总报表" },
                  name: "menu_sys_report_total",
                  component: () => import("@/pages/global/report_total"),
                },
                {
                  path: "/global/report_daily",
                  meta: { icon: "el-icon-s-marketing", title: "收益日报表" },
                  name: "menu_sys_report_daily",
                  component: () => import("@/pages/global/report_daily"),
                },
                {
                  path: "/global/report_app_daily",
                  meta: { icon: "el-icon-s-opportunity", title: "应用收益报表" },
                  name: "menu_sys_report_app_daily",
                  component: () => import("@/pages/global/report_app_daily"),
                },
                {
                  path: "/global/report_app",
                  meta: { icon: "el-icon-s-grid", title: "应用集合报表" },
                  name: "menu_sys_report_app",
                  component: () => import("@/pages/global/report_app"),
                },
                {
                  path: "/global/report_api",
                  meta: { icon: "el-icon-s-management", title: "接口花费报表" },
                  name: "menu_sys_report_api",
                  component: () => import("@/pages/global/report_api"),
                },
              ],
            },
            {
              path: "/global/ai",
              component: SecondLayout,
              meta: { icon: "el-icon-s-comment", title: "AI管理" },
              name: "menu_global_ai",
              redirect: "/global/ai/keys",
              children: [
                {
                  path: "/global/ai/config",
                  meta: { icon: "el-icon-s-fold", title: "渠道配置" },
                  name: "menu_global_ai_keys",
                  component: () => import("@/pages/global/ai_config"),
                },
                {
                  path: "/global/ai/keys",
                  meta: { icon: "el-icon-s-fold", title: "渠道账号" },
                  name: "menu_global_ai_keys",
                  component: () => import("@/pages/global/ai_keys"),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "/app/:appId",
      name: "AppLayout",
      component: AppLayout,
      redirect: "/app/:appId/dashboard",
      children: [
        {
          path: "/app/:appId/dashboard",
          component: () => import("@/pages/app/index"),
          meta: { icon: "el-icon-s-home", title: "应用概览" },
          name: "menu_app_dahboard",
        },
        {
          path: "/app/:appId/report",
          component: SecondLayout,
          meta: { icon: "el-icon-s-data", title: "数据报表" },
          name: "menu_report",
          redirect: "/app/:appId/report/user",
          children: [
            {
              path: "/app/:appId/report/user",
              component: () => import("@/pages/report/user"),
              name: "menu_report_user",
              meta: { icon: "", title: "日用户报表" },
            },
            {
              path: "/app/:appId/report/daily",
              component: () => import("@/pages/report/daily"),
              name: "menu_report_daily",
              meta: { icon: "", title: "日详情报表" },
            },
            {
              path: "/app/:appId/report/hourly",
              component: () => import("@/pages/report/hourly"),
              name: "menu_report_hourly",
              meta: { icon: "", title: "小时趋势报表" },
            },
            {
              path: "/app/:appId/report/country",
              component: () => import("@/pages/report/country"),
              name: "menu_report_country",
              meta: { icon: "", title: "国家付款率报表" },
            },
          ],
        },

        {
          path: "/app/:appId/order",
          component: SecondLayout,
          meta: { icon: "el-icon-s-flag", title: "订单管理" },
          name: "menu_data",
          redirect: "/app/:appId/order",
          children: [
            {
              path: "/app/:appId/order",
              component: () => import("@/pages/order/index"),
              meta: { icon: "", title: "订单列表" },
              name: "menu_order_list",
            },
          ],
        },
        {
          path: "/app/:appId/user",
          component: SecondLayout,
          meta: { icon: "el-icon-user-solid", title: "用户管理" },
          name: "menu_check",
          redirect: "/app/:appId/user/list",
          children: [
            {
              path: "/app/:appId/user/list",
              component: () => import("@/pages/user/list"),
              meta: { icon: "", title: "用户列表" },
              name: "menu_user_list",
            },
            {
              path: "/app/:appId/user/install",
              component: () => import("@/pages/user/install"),
              meta: { icon: "", title: "用户安装" },
              name: "menu_user_install",
            },
            {
              path: "/app/:appId/user/costList",
              component: () => import("@/pages/user/cost_list"),
              meta: { icon: "", title: "消费明细" },
              name: "menu_user_consume",
            },
            {
              path: "/app/:appId/user/chatList",
              component: () => import("@/pages/user/chat_list"),
              meta: { icon: "", title: "聊天记录" },
              name: "menu_user_chatlog",
            },
            {
              path: "/app/:appId/user/signList",
              component: () => import("@/pages/user/sign_list"),
              meta: { icon: "", title: "签到记录" },
              name: "menu_user_sign_list",
            },
             {
               path: "/app/:appId/user/feedback",
              component: () => import("@/pages/user/feedback_list"),
              meta: { icon: "", title: "用户反馈" },
              name: "menu_user_feedback",
            },
            /*{
              path: '/app/:appId/user/blackList',
              component: () => import('@/pages/user/black_list'),
              meta:{ icon:"", title:'用户黑名单'},
              name: 'menu_user_black_list',
            },*/
          ],
        },
        {
          path: "/app/:appId/config",
          component: SecondLayout,
          meta: { icon: "el-icon-s-tools", title: "应用配置" },
          name: "menu_config",

          redirect: "/app/:appId/config/index",
          children: [
            {
              path: "/app/:appId/role",
              component: () => import("@/pages/role/index"),
              meta: { icon: "", title: "角色列表" },
              name: "menu_role_index",
            },
            {
              path: "/app/:appId/product",
              component: () => import("@/pages/product/index"),
              meta: { icon: "", title: "商品列表" },
              name: "menu_product_index",
            },
            {
              path: "/app/:appId/activity",
              component: () => import("@/pages/activity/index"),
              meta: { icon: "", title: "活动列表" },
              name: "menu_activity_index",
            },
            {
              path: "/app/:appId/config/category",
              component: () => import("@/pages/config/category"),
              meta: { icon: "", title: "分类配置" },
              name: "menu_config_category",
            },
            {
              path: "/app/:appId/config/index",
              component: () => import("@/pages/config/index"),
              meta: { icon: "", title: "远程配置" },
              name: "menu_config_index",
            },
            {
              path: "/app/:appId/config/parameter",
              component: () => import("@/pages/config/parameter"),
              meta: { icon: "", title: "配置参数" },
              name: "menu_config_parameter",
            },
          ],
        },
        {
          path: "/app/:appId/push",
          component: SecondLayout,
          meta: { icon: "el-icon-s-promotion", title: "消息推送" },
          name: "menu_push",
          redirect: "/app/:appId/push/index",
          children: [
            {
              path: "/app/:appId/push/index",
              component: () => import("@/pages/push/index"),
              meta: { icon: "", title: "推送预览" },
              name: "menu_push_index",
            },
            {
              path: "/app/:appId/push/role",
              component: () => import("@/pages/push/role"),
              meta: { icon: "", title: "定时任务" },
              name: "menu_push_role",
            },
            {
              path: "/app/:appId/push/user",
              component: () => import("@/pages/push/user"),
              meta: { icon: "", title: "订阅用户" },
              name: "menu_push_user",
            },
            {
              path: "/app/:appId/push/log",
              component: () => import("@/pages/push/log"),
              meta: { icon: "", title: "推送日志" },
              name: "menu_push_log",
            },
          ],
        },
      ],
    },
    { path: "/login", component: Login, hidden: true, meta: { title: "登录" } },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "管理系统";
  }
  if (to.path != "/login") {
    // 判断是否需要登录权限
    if (localStorage.getItem("token")) {
      // 判断是否登录
      next();
    } else {
      // 没登录则跳转到登录界面
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js